import { formatMoney } from '@/glow';
import selectors from '@/lib/selectors';

const { product: selector } = selectors;
const classes = {
  activeThumb: 'active-thumbnail',
  hide: 'hide',
};

export default function (variant) {
  const section = this.container;

  const comparePrice = section.querySelector(selector.comparePrice);
  const compareEls = section.querySelectorAll(
    `${selector.comparePrice}, ${selector.comparePriceText}`
  );

  const productPrices = [...section.querySelectorAll(selector.price)];

  productPrices.forEach(el => (el.innerHTML = formatMoney(variant.price)));

  if (variant.compare_at_price > variant.price) {
    comparePrice.innerHTML = formatMoney(variant.compare_at_price);
    compareEls.forEach(el => el.classList.remove(classes.hide));
    productPrices.forEach(el => el.classList.add('sale'));
  } else {
    comparePrice.innerHTML = '';
    compareEls.forEach(el => el.classList.add(classes.hide));
    productPrices.forEach(el => el.classList.remove('sale'));
  }
}
